import {Stack} from 'src/design/atoms/Stack';
import React from 'react';

import {BackBar} from 'src/app/layout/BackBar';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkTestArea} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {ThrowApiExceptionButton} from './components/ThrowApiExceptionButton';
import {ThrowValidationExceptionButton} from './components/ThrowValidationExceptionButton';

export const TestApiInteractionsPage: React.FC = () => {
  return (
    <ContentWrapper>
      <Stack gap="lg">
        <BackBar
          fallbackTo={PathUtility.AdminTestArea()}
          fallbackLabel="Back to Test Area"
          breadcrumbs={[
            {label: 'System', to: PathUtility.AdminSystem()},
            {label: 'Test Area', to: PathUtility.AdminTestArea()},
            {label: 'Test API Interactions'},
          ]}
        />
        <PageHeader>
          <PageHeader.Title
            icon={SidebarLinkTestArea.icon}
            subtitle="Test error handling and API responses">
            Test API Interactions
          </PageHeader.Title>
        </PageHeader>
        <Stack w={{base: '100%', lg: '250px'}} gap="sm">
          <ThrowApiExceptionButton />
          <ThrowValidationExceptionButton />
        </Stack>
      </Stack>
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.AdminTestApiInteractions(),
  element: <TestApiInteractionsPage />,
  isPrivate: true,
  requireSuperAdmin: true,
});

export default TestApiInteractionsPage;
